import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getBlogAsync, saveUnSaveBlogAsync, addLikeAsync } from "./BlogAPI";

const sliceName = "blog";
const initialState = {
    blog: {},
    isLoading: false,
    isError: false,
    errorMessage: ''
};

export const fetchBlog = createAsyncThunk(`${sliceName}/fetchBlog`, getBlogAsync);
export const saveUnSaveBlog = createAsyncThunk(`${sliceName}/saveUnSaveBlog`, saveUnSaveBlogAsync);
export const addLike = createAsyncThunk(`${sliceName}/addLike`, addLikeAsync);

const blogSlice = createSlice({
    name: sliceName,
    initialState,
    extraReducers: (builder) => {
        builder
            .addCase(fetchBlog.pending, (state) => {
                state.isLoading = true;
            })
            .addCase(fetchBlog.fulfilled, (state, action) => {
                state.isLoading = false;
                state.blog = action.payload;
            })
            .addCase(fetchBlog.rejected, (state, action) => {
                state.isError = true;
                state.isLoading = false;
                state.errorMessage = action.error?.message;
                state.blog = {};
            });
        
        builder
            .addCase(saveUnSaveBlog.pending, () => {})
            .addCase(saveUnSaveBlog.fulfilled, () => {})
            .addCase(saveUnSaveBlog.rejected, () => {});

        builder
            .addCase(addLike.pending, () => {})
            .addCase(addLike.fulfilled, () => {})
            .addCase(addLike.rejected, () => {});
    }
});

export default blogSlice.reducer;
